
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import TopBannerSection from './home/TopBannerSection.vue';
import AboutUsSection from './home/AboutUsSection.vue';
import ProductSection from './home/ProductSection.vue';
import FactorySection from './home/FactorySection.vue';
import {
  getHomePageData,
  getVehicleTypeList,
  getArticleListByTypes,
  getFactories
} from '@/api/apis';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  components: {
    TopBannerSection,
    AboutUsSection,
    ProductSection,
    FactorySection
  },
  created() {
    this.loadData();

    // setTimeout(() => {
    //   document.body.scrollTop = document.documentElement.scrollTop = 100;
    // }, 300);
  },
  data() {
    return {
      imgs: [],
      vehicleTypes: [],
      products: [],
      factories: [],
      articles: [],
      loaded: false
    };
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang() {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      const res = await Promise.all([
        getHomePageData(),
        getVehicleTypeList(),
        getArticleListByTypes({
          types: [1, 2, 3].join(',')
        })
      ]);

      if (res && res.length === 3 && res.every(s => s.success)) {
        const homePageData = res[0].result || [];
        this.imgs = homePageData
          .filter(s => s.type === 0 && s.content)
          .map(s => {
            return baseUrl + s.content;
          });

        this.articles = res[2].result || [];

        this.vehicleTypes = (res[1].result || []).filter(s => s.indexShow);

        const news = homePageData
          .filter(s => s.type === 1 && s.content && !isNaN(+s.content))
          .map(s => +s.content);

        if (news.length > 0) {
          const fRes = await getFactories({
            newsIds: news.join(',')
          });

          if (fRes.success) {
            this.factories = fRes.result || [];
          }
        }
      }

      this.loaded = true;
    }
  }
});
